<template>
    <CompassTableHead isFixed class="automation-listing-table-head">
        <CompassTableHeadCell
            v-for="column in columns"
            :id="column.code"
            :key="column.code"
            :sortable="column.sortable"
            :alignContent="column.alignContent"
            :fitContent="column.fitContent"
            @click="$emit('sort-table-head', { orderBy: column.code })"
        >
            {{ column.label }}
        </CompassTableHeadCell>
    </CompassTableHead>
</template>

<script>
export default {
    props: {
        columns: {
            type: Array,
            required: true,
        },
    },
    emits: ['sort-table-head'],
};
</script>
